import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 40px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledCardsContainer = styled.div`
	margin-top: 20px;
`;

const StyledHousesContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;
`;

const StyledDaysInputContainer = styled.div`
	margin-top: 10px;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
	margin-top: 20px;
`;

const StyledInfoRow = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 20px;
	gap: 10px;
	align-items: center;

	${Text} {
		color: #ffffff;

		&:nth-child(1) {
			font-size: 16px;
			opacity: 0.25;
		}

		&:nth-child(2) {
			font-weight: 500;
			font-size: 16px;
		}
	}

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledButtonContainer = styled.div`
	position: absolute;
	bottom: 70px;
	width: calc(100% - 40px);
`;

export {
	StyledButtonContainer,
	StyledCardsContainer,
	StyledDaysInputContainer,
	StyledHead,
	StyledHousesContainer,
	StyledInfoContainer,
	StyledInfoRow,
};
